import React, { useEffect } from 'react';
import {
    Card,
    ExamTable,
    IMultiSelectSectionFetchList,
    MultiSelectSection,
    PaginationData,
} from 'components';
import { getExamStatusMapping } from 'components/enums'
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { IExam } from '../../api/ApiClient';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { IGetExamsList } from '../../redux/models/exam';
import { useLocalErrorHandler } from 'hooks';

const ExamListContainer = ({
                               getExams,
                               setErrorHandler,
                               examList,
                               onPush,
                               apiError,
                               qualificationList,
                               getQualifications,
                               clearExpertsList,
                           }: Props) => {
    useLocalErrorHandler(setErrorHandler);

    useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            clearExpertsList();
            await getExams({ sortField: 'date', sortOrder: false });
            await getQualifications({ pageSize: 200 });
            setProcessing(false);
        };

        fetch();
    }, []);

    const initialState: IState = {
        attestationSubCommissionIds: [],
        qualificationIds: [],
    };
    //const [accreditationCenterIds, setAccreditationCenterIds] = React.useState(initialState.attestationSubCommissionIds);
    const [qualificationIds, setQualificationIds] = React.useState(initialState.qualificationIds);
    const [processing, setProcessing] = React.useState(false);

    const HEADER = [
        'ПЕРИОД ПРОВЕДЕНИЯ',
        'Специальность',
        'Статус',
    ];

    const fetchExamsDefault = (props?: IGetExamsList) => getExams({
        sortField: 'date',
        sortOrder: false,
        //accreditationCenterIds,
        qualificationIds,
        ...props,
    });

    const handleChangePagination = (newPagination: PaginationData) => {
        fetchExamsDefault({ ...newPagination, pageSize: newPagination.perPage });
    };

    const handleChooseExam = (id?: string) => {
        if (!id) return;

        onPush(`/exam/${id}?from=exam-list`);
    };

    const getExamData = (exam: IExam) => ({
        ...exam,
        status: getExamStatusMapping(exam.status, exam.currentStageNumber),
        name: exam.qualificationTitle,
    });

    const fetchList = (data: IMultiSelectSectionFetchList) => {
        //setAccreditationCenterIds(data.accreditationCenterIds || []);
        setQualificationIds(data.qualificationIds || []);

        getExams({ sortField: 'date', sortOrder: false, ...data });
    };

    return (
      <Card
        withoutPadding
        title="Список аккредитаций"
        category="Поиск и просмотр"
        apiError={apiError}
        showLoader={processing}
        show404Error={!examList}
      >
          <MultiSelectSection
            fetchList={fetchList}
            examSelectStatusName="ExamListFilters"
            qualificationList={qualificationList}
          />
          {examList && (
            <ExamTable
              header={HEADER}
              tableRows={examList.items ? examList.items.map(getExamData) : []}
              onChooseExam={handleChooseExam}
              pagination={examList}
              onChangePagination={handleChangePagination}
              placeholderTitle="Нет аккредитаций в списке"
              placeholderText="Здесь будут отображаться все аккредитации, 
проводившиеся в рамках АПК"
            />
          )}
      </Card>
    );
};

const mapState = (state: IRootState) => ({
    examList: state.exams.examsList,
    qualificationList: state.qualifications.qualificationList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    clearExpertsList: dispatch.experts.clearExpertsList,
    getExams: dispatch.exams.getExamsAsync,
    getQualifications: dispatch.qualifications.getQualificationsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(ExamListContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

interface IState {
    attestationSubCommissionIds: string[];
    qualificationIds: string[];
}
